import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import BaseDialog from '../../../../../components/BaseDialog/BaseDialog';

import { getString } from '../../../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';
import theme from '../../../../../theme';

const stringsComponent = 'confirmConsentDialog';

class ConfirmConsentDialog extends React.Component {
  field(label, value) {
    const { classes } = this.props;

    if (value) {
      return (
        <div className={classes.field}>
          <Typography component='div' className={classes.label}>
            {label}
          </Typography>
          <Typography component='div' className={classes.value}>
            {value}
          </Typography>
        </div>
      );
    }
  }

  render() {
    const {
      classes,
      open,
      cancel,
      confirm,
      name,
      relationship,
      address,
      phone,
      dateOfBirth,
      dialogText,
    } = this.props;

    return (
      <div className={classes.root}>
        <BaseDialog
          open={open}
          content={
            <React.Fragment>
              <Typography className={classes.dialogText}>
                {dialogText}
              </Typography>
              <div className={classes.changes}>
                {this.field(getString(stringsComponent, 'NAME_LABEL'), name)}
                {this.field(
                  getString(stringsComponent, 'RELATIONSHIP_LABEL'),
                  relationship
                )}
                {this.field(
                  getString(stringsComponent, 'ADDRESS_LABEL'),
                  address
                )}
                {this.field(getString(stringsComponent, 'PHONE_LABEL'), phone)}
                {this.field(
                  getString(stringsComponent, 'DOB_LABEL'),
                  dateOfBirth
                )}
                {this.field(
                  getString(stringsComponent, 'END_DATE_LABEL'),
                  getString(stringsComponent, 'END_DATE_VALUE')
                )}
              </div>
              <Typography component='div' className={classes.confirmationText}>
                {getString(stringsComponent, 'CONFIRMATION_TEXT')}
              </Typography>
            </React.Fragment>
          }
          contentWrap={false}
          title={getString(stringsComponent, 'CONFIRM_TITLE')}
          buttonAction={confirm}
          buttonLabel={getString(stringsComponent, 'SUBMIT_BUTTON_LABEL')}
          secondaryButtonAction={cancel}
          secondaryButtonLabel={getString(
            stringsComponent,
            'CANCEL_BUTTON_LABEL'
          )}
          icon={PersonOutlineIcon}
          classes={{
            icon: classes.avatar,
            heading: classes.heading,
          }}
        />
      </div>
    );
  }
}

ConfirmConsentDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  name: PropTypes.string,
  relationship: PropTypes.string,
  address: PropTypes.string,
  phone: PropTypes.string,
  dateOfBirth: PropTypes.string,
  dialogText: PropTypes.string,
};

ConfirmConsentDialog.defaultProps = {
  open: false,
  dialogText: '',
};

export default withStyles(styles)(ConfirmConsentDialog);
